import axios from 'axios';
import bugsnag from 'bugsnag-js';
import Cookies from "universal-cookie";


import { StoreDispatch } from '~/redux/store';


const url = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BACKEND_ENDPOINT!
    : process.env.REACT_APP_LOCAL_ENDPOINT!;

const bugsnagClient = bugsnag('8822370330acd587983bc49c6f829cd4');

export const GET_EVENT_STRUCTURES = 'GET_EVENT_STRUCTURES';
export const GET_INTERESTS = 'GET_INTERESTS';

export const getEventStructures = () => (dispatch: StoreDispatch) => {
  const cookies = new Cookies();
  const token = cookies.get('token') || sessionStorage.getItem('token');
  
  axios({
    url: `${url}/eventstructure`,
    method: 'GET',
    headers: { token },
  })
    .then((response) => {
      dispatch({
        type: GET_EVENT_STRUCTURES,
        payload: response.data,
      });
    })
    .catch((error) => {
      bugsnagClient.notify(error);
    });
};

export const getInterests = () => (dispatch: StoreDispatch) => {
  const cookies = new Cookies();
  const token = cookies.get('token') || sessionStorage.getItem('token');
  
  axios({
    url: `${url}/interest`,
    method: 'GET',
    headers: { token },
  })
    .then((response) => {
      dispatch({
        type: GET_INTERESTS,
        payload: response.data,
      });
    })
    .catch((error) => {
      bugsnagClient.notify(error);
    });
};
